import React, { useEffect, useState } from "react";
import { Button, Input, message, Steps } from "antd";
import X from "../../../assets/imgs/circle-x.png";
import Add from "../../../assets/imgs/add.png";
import check from "../../../assets/imgs/check.png";
import polygon from "../../../assets/imgs/draw-polygon.png";
import pen from "../../../assets/imgs/pen-clip.png";
import checkWhite from "../../../assets/imgs/check-white.png";
import lightbulb from "../../../assets/imgs/lightbulb.png";
import styles from "./style.module.css";
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
} from "@mui/material";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import apiEndPoint from "../../../services/apiService/apiEndPoints";
import { getApi, postApi } from "../../../services/apiService/fetchMethod";
import { socket, socket2 } from "../../../socket/socket";
import MainLoader from "../../../commonComponents/loader/MainLoader";
import Step1 from "../../../components/home/step1";
import ImageAnnotate from "../../../components/home/ImageAnnotate";
import { MdOutlineCurrencyRupee } from "react-icons/md";
import {
  setSelectedPipeline,
  setSelectedVideoHome,
} from "../../../redux/slice/videoSlice";
import decrypt from "../../../services/hash-service/decrypt-service";
import { Line } from "rc-progress";
import { Collapse } from "antd";
import { imgUrlChange2 } from "../../../utils/imgUrlChanger";
import getUserData from "../../../utils/getUserData";
import { setCreditScore } from "../../../redux/slice/filterSlice";
const { Panel } = Collapse;

const steps = [
  {
    title: "Upload Video",
    content: "First-content",
  },
  {
    title: "Select Use Case",
    content: "Second-content",
  },
  {
    title: "Mark Boundaries",
    content: "Last-content",
  },
  {
    title: "Finish!",
    content: "Last-content",
  },
];
const Step2 = () => {
  const [image] = useState(new window.Image());
  const [current, setCurrent] = useState(0);
  const [rowData, setRowData] = useState([]);
  const [addItem, setAddItem] = useState([]);
  const [selectedAlert, setSelectedAlert] = useState("");
  const [videoBase64, setVideoBase64] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [rtspUrl, setRtspUrl] = useState("");
  const [url, setUrl] = useState("");
  const [loading, setloading] = useState(false);
  const [loading2, setloading2] = useState(false);
  const [open, setOpen] = useState(false);
  const [drawingData, setDrawingData] = useState(false);
  const [videoDetails, setVideoDetails] = useState(null);
  const [clickUpload, setClickUpload] = useState(true);
  const [title, setTitle] = useState("Sample" + Date.now());
  const [toDivid, setToDivid] = useState(1);
  const [progress, setProgress] = useState(0);
  const [clickOnUploadBtn, setClickOnUploadBtn] = useState(false);
  let [roiName, setRoiName] = useState({});
  let [lcName, setLcName] = useState({});
  const [isMultiDomain, setIsMultiDomain] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  let { selectedProject } = getUserData();
  selectedProject = selectedProject.value;
  const [notCommingSoon, setNotCommingSoon] = useState([
    "65ae0675b52522368a248ec5",
    "65ae0699b52522368a248edd",
    "65ae06c3b52522368a248ee9",
    "65ae0686b52522368a248ed1",
    "65ae0c93b52522368a248f31",
    "65fbc4a3668dfea9ecf093ac",
    "65ae0d13b52522368a248f55",
    "65ae0bf6b52522368a248f01",
    "65ae0c06b52522368a248f0d",
    "65ae0d4ab52522368a248f6d",
  ]);
  const [doneBtnClick, setDoneBtnClick] = useState(false);
  const { selectedPipeline, selectedVideoHome } = useSelector(
    (data) => data.videoReducer
  );
  const { creditScore } = useSelector((state) => state.filter);
  const dispatch = useDispatch();
  const handleOpen = (id) => {
    if (id) {
      setSelectedAlert(id);
    }
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "100%",
    height: "100%",
    overflow: "auto",
    transform: "translate(-50%, -50%)",
    borderRadius: 1,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };
  const next = () => {
    setCurrent(current + 1);
  };
  const prev = () => {
    setCurrent((pre) => {
      if (pre === 1) {
        setVideoDetails(null);
      }
      return pre - 1;
    });
  };
  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));
  const fetchAllData = async () => {
    const url = apiEndPoint().GET_ALERT_LIST_ALL + 2;
    const { status, data } = await getApi({
      url,
    });
    if (status === 200) {
      setRowData(data.data);
    }
  };
  const markingFunc = (drawingData) => {
    if (drawingData) {
      let marking = JSON.parse(JSON.stringify(drawingData));
      for (let key in marking) {
        if (marking[key] && typeof marking[key] === "object") {
          for (let innerKey in marking[key]) {
            if (Array.isArray(marking[key][innerKey])) {
              marking[key][innerKey].forEach((arr) => {
                arr.forEach((point) => {
                  point.x = Math.floor(point.x / toDivid);
                  point.y = Math.floor(point.y / toDivid);
                });
              });
            }
          }
        }
      }
      let strLine = {};
      let strRoi = {};
      let newVal = 0;
      let newValClear = 0;
      let classes = {};
      for (let key in marking) {
        let roiNames = roiName[key];
        let lcNames = lcName[key];
        if (marking[key]?.lines?.length) {
          marking[key].lines.forEach((item) => {
            newVal += 1;
            item.forEach((item2) => {
              if (newVal === 3) {
                newValClear += 1;
                newVal = 0;
              }
              strLine[lcNames[newValClear]] = strLine[lcNames[newValClear]]
                ? strLine[lcNames[newValClear]] + `${item2.x};${item2.y};`
                : `${item2.x};${item2.y};`;
            });
          });
          classes[key] = { ...strLine, type: "line" };
          strLine = {};
        }
        if (marking[key]?.polygons?.length) {
          marking[key].polygons.forEach((item, i) => {
            item.forEach((item2) => {
              strRoi[roiNames[i]] = strRoi[roiNames[i]]
                ? strRoi[roiNames[i]] + `${item2.x};${item2.y};`
                : `${item2.x};${item2.y};`;
            });
          });
          classes[key] = { ...classes[key], ...strRoi, type: "roi" };
          strRoi = {};
        }
      }
      return classes;
    }
  };
  useEffect(() => {
    fetchAllData();
  }, []);
  const handleRemove = (id, domainName) => {
    setAddItem((pre) => pre.filter((item) => item._id !== id));
    dispatch(setSelectedPipeline({}));
    setIsMultiDomain((pre) => {
      let valueToRemove = domainName;
      let index = pre.lastIndexOf(valueToRemove);
      if (index !== -1) {
        pre.splice(index, 1);
      }
      return pre;
    });
  };
  const handleSelect = (item, domainName) => {
    if (isMultiDomain.length && isMultiDomain[0] !== domainName) {
      message.error(
        <span>
          You've selected{" "}
          <span style={{ fontWeight: "600" }}>{isMultiDomain[0]}</span>.To add{" "}
          <span style={{ fontWeight: "600" }}>{domainName}</span>, first remove{" "}
          <span style={{ fontWeight: "600" }}>{isMultiDomain[0]}</span>
        </span>
      );
    } else {
      setAddItem((pre) => [
        ...pre,
        {
          _id: item._id,
          name: item.alert_name,
          marking: item?.marking?.map((item) => item.value),
          price: item?.price,
        },
      ]);
      dispatch(setSelectedPipeline({}));
      setIsMultiDomain((pre) => [...pre, domainName]);
    }
  };
  const handleSubmitAnnotate = (data) => {
    let val = false;
    if (lcName[selectedAlert] && lcName[selectedAlert].includes("")) {
      val = true;
    }
    if (roiName[selectedAlert] && roiName[selectedAlert].includes("")) {
      val = true;
    }
    if (val) {
      message.error("Please fill all the fields");
      return;
    }
    setDrawingData((pre) => ({ ...pre, [selectedAlert]: data }));
    setOpen(false);
    dispatch(setSelectedPipeline({}));
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setVideoBase64(file);
    }
    setVideoDetails(null);
  };
  const uploadVideo = async () => {
    if (!videoDetails) {
      try {
        if (videoUrl) {
          setloading(true);
          const url = apiEndPoint().upload_video;
          const { data, status } = await postApi({
            url,
            params: {
              publicUrl: videoUrl,
              withoutEncrypt: true,
            },
          });
          if (status === 200) {
            setVideoDetails(data.data);
            setUrl(imgUrlChange2(data.data.framePath));
            next();
          }
          setloading(false);
        } else if (rtspUrl) {
          setloading(true);
          const url = apiEndPoint().upload_video;
          const { data, status } = await postApi({
            url,
            params: {
              rtspUrl: rtspUrl,
              withoutEncrypt: true,
            },
          });
          if (status === 200) {
            setVideoDetails(data.data);
            setUrl(imgUrlChange2(data.data.framePath));
            next();
          }
          setloading(false);
        } else {
          setloading(true);
          setClickOnUploadBtn(true);
          const url = apiEndPoint().upload_video;
          const formData = new FormData();
          formData.append("videoFile", videoBase64);
          let { data, status } = await axios.post(url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setProgress(percentCompleted);
            },
          });
          if (data.encryptData) {
            data = decrypt(data?.encryptData);
          }
          if (status === 200) {
            setVideoDetails(data.data);
            setUrl(imgUrlChange2(data.data.framePath));
            setloading(false);
            setClickOnUploadBtn(false);
            setProgress(0);
            next();
          }
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      next();
    }
  };
  const handleCancel = () => {
    setCurrent(0);
    setClickUpload(true);
    setAddItem([]);
    setSelectedAlert("");
    setVideoBase64("");
    setVideoUrl("");
    setUrl("");
    setDrawingData({});
    setVideoDetails(null);
    setTitle("Sample" + Date.now());
    setClickUpload(true);
    setIsMultiDomain([]);
    setRtspUrl("");
    setRoiName({});
    setLcName({});
  };
  const createMedia = async () => {
    try {
      let token = localStorage.getItem("Token");
      if (!token) {
        setOpen(true);
        return;
      }
      const url = apiEndPoint().CREATE_PIPELINE;
      let params = {
        creditScore: addItem.reduce((a, b) => a + b.price * 2, 0),
        deviceId: localStorage.getItem("gpu"),
      };
      if (addItem.length) {
        params.alerts = addItem.map((item) => item._id);
      }
      if (drawingData) {
        params.classes = markingFunc(drawingData);
      }
      if (rtspUrl) {
        params.cam_id = deviceList.filter(
          (item) => item.value === rtspUrl
        )[0]?.id;
        params.cam_rtsp = rtspUrl;
      }
      const result = await postApi({ url, params });
      if (result?.status === 200) {
        const sendSocket = {
          projectId: selectedProject,
          warehouseId: result.data.data.warehouseId,
          deviceId: result.data.data.deviceId,
          command: "yaml-update",
          responseId: Date.now(),
          sent_by: "ME",
        };
        socket2.emit("sendMessageToDevice", sendSocket);
        setloading2(true);
        setClickUpload(true);
        setAddItem([]);
        setSelectedAlert("");
        setVideoBase64("");
        setVideoUrl("");
        setUrl("");
        setDrawingData({});
        setVideoDetails(null);
        setTitle("Sample" + Date.now());
        setCurrent(0);
        dispatch(setSelectedVideoHome(null));
        setProgress(0);
        setClickOnUploadBtn(false);
        setIsMultiDomain([]);
        setRtspUrl("");
        setRoiName({});
        setLcName({});
        socket.emit("start_pipeline", { ...sendSocket, time: Date.now() });
      } else {
        setDoneBtnClick(false);
        message.error(result?.data?.message);
        setOpen(false);
      }
    } catch (error) {
      setDoneBtnClick(false);
      console.log(error, "errrrr");
      message.error("somthing Went Wrong");
      setOpen(false);
    }
  };

  useEffect(() => {
    (async () => {
      if (localStorage.getItem("Token")) {
        const url = apiEndPoint().GET_CREDIT;
        const { data, status } = await getApi({ url });
        if (status === 200) {
          if (data?.data?.credit_score !== creditScore?.credit_score) {
            dispatch(setCreditScore(data?.data));
          }
        }
      }
    })();
  }, []);
  useEffect(() => {
    (async () => {
      let url = apiEndPoint().GET_DEVICE_LIST_FILTER;
      const { status, data } = await getApi({ url });
      if (status === 200) {
        setDeviceList(data.data);
      }
    })();
  }, []);
  useEffect(() => {
    // if (creditScore?.acc_type === "Premium") {
    let val = [];
    rowData.forEach((item) => {
      let val2 = item.children
        .filter((item2) => item2.usecase_type === "advance")
        .map((item3) => item3._id);
      val = [...val, ...val2];
    });

    setNotCommingSoon(val);
    // }
  }, [creditScore, rowData]);

  const isDisableBtn = (data) => {
    if (data === 0) {
      return videoBase64 || videoUrl || rtspUrl ? false : true;
    } else if (data === 1) {
      return addItem.length ? false : true;
    } else if (data === 2) {
      let arr = addItem.map((item, i) => {
        return (
          drawingData[item._id]?.lines?.length ||
          drawingData[item._id]?.polygons?.length
        );
      });
      return arr.includes(undefined) || arr.includes(0) ? true : false;
    } else if (data === 3) {
      let arr = addItem.map((item, i) => {
        return (
          drawingData[item._id]?.lines?.length ||
          drawingData[item._id]?.polygons?.length
        );
      });
      return arr.includes(undefined) || arr.includes(0) ? true : false;
    }
  };

  function convertToMinutes(timeStr) {
    const timeParts = timeStr.split(":");
    const hours = parseInt(timeParts[0], 10);
    const minutes = parseInt(timeParts[1], 10);
    const seconds = parseInt(timeParts[2], 10);
    const totalMinutes = hours * 60 + minutes + seconds / 60;
    let returnVal = Math.floor(totalMinutes);
    return returnVal === 0 ? 1 : returnVal;
  }

  if (loading) {
    return clickOnUploadBtn ? (
      <div
        style={{
          width: "100%",
          height: "90vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div style={{ width: "350px" }}>
          <div style={{ textAlign: "center", color: "blue " }}>
            Upload Progress: {progress}%
          </div>
          <Line percent={progress} strokeWidth="2" strokeColor="blue" />
        </div>
      </div>
    ) : (
      <MainLoader />
    );
  }
  return clickUpload ? (
    <div>
      <Step1 setClickUpload={setClickUpload} />
    </div>
  ) : (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ marginRight: "1rem" }}>
          <Input
            type="text"
            style={{
              fontWeight: 500,
              fontSize: "20px",
              color: "gray",
            }}
            placeholder="Enter Your Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
        <div>
          <button className={styles.cancel} onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </div>
      <br />
      <Steps current={current} items={items} />
      {current === 0 ? (
        <Grid container spacing={2}>
          {/* <Grid item xs={12} sm={4}>
            <div className={styles.box1}>
              {videoBase64 ? (
                <label
                  htmlFor="file"
                  className={styles.uploadVideo}
                  style={{ background: "green" }}
                >
                  <MdCloudDone size={22} style={{ marginRight: "5px" }} />
                  Video Selected
                </label>
              ) : (
                <label htmlFor="file" className={styles.uploadVideo}>
                  <MdOutlineCloudUpload
                    size={22}
                    style={{ marginRight: "5px" }}
                  />
                  Select Video
                </label>
              )}

              <input
                type="file"
                id="file"
                style={{ display: "none" }}
                accept="video/*"
                onChange={handleFileChange}
              />
            </div>
          </Grid> */}
          <Grid item xs={12} sm={4}>
            {/* <div className={styles.box1} style={{ flexDirection: "column" }}>
              <input
                type="text"
                placeholder="Paste RTSP URL here"
                className={styles.pasteVideo}
                value={rtspUrl}
                onChange={(e) => setRtspUrl(e.target.value)}
              />
            </div> */}

            <div style={{ paddingBlock: "3rem", width: "100%" }}>
             
              {/* <Select
                placeholder="Select a camera"
                size="large"
                style={{ width: "100%" }}
                onChange={(val) => setRtspUrl(val)}
                options={deviceList}
                virtual 
              /> */}
              <FormControl fullWidth size="medium">
                <InputLabel id="camera-select-label">
                  Select a camera
                </InputLabel>
                <Select
                  labelId="camera-select-label"
                  label="Select a camera"
                  onChange={(event) => setRtspUrl(event.target.value)}
                  style={{ width: "100%" }}
                >
                  {deviceList.map((device) => (
                    <MenuItem key={device.value} value={device.value}>
                      {device.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </Grid>
          {/* <Grid item xs={12} sm={4}>
            <div className={styles.box1} style={{ flexDirection: "column" }}>
              <input
                type="text"
                placeholder="Paste Video URL here"
                className={styles.pasteVideo}
                value={videoUrl}
                onChange={(e) => setVideoUrl(e.target.value)}
              />
            </div>
          </Grid> */}
        </Grid>
      ) : current === 1 ? (
        <div className={styles.step2Box}>
          <Collapse defaultActiveKey={["0"]}>
            {rowData.map((list, i) => (
              <Panel
                header={
                  <div
                    style={{ textTransform: "capitalize", fontWeight: "600" }}
                  >
                    {list.displayName ? list.displayName : list.name}
                  </div>
                }
                key={i}
              >
                {list?.children?.map((item, i) => {
                  return (
                    <div
                      key={i}
                      className={
                        addItem.some((item2) => item2._id === item._id)
                          ? styles.itemBox
                          : styles.itemBoxAdd
                      }
                    >
                      <div>{item.alert_name}</div>
                      {addItem.some((item2) => item2._id === item._id) ? (
                        <button
                          className={styles.removeBtn}
                          onClick={() => handleRemove(item._id, list.name)}
                        >
                          <img
                            src={X}
                            height={15}
                            width={15}
                            style={{ marginRight: "5px" }}
                            alt="x"
                          />
                          Remove
                        </button>
                      ) : !notCommingSoon?.includes(item._id) ? (
                        <Button type="primary" disabled>
                          Coming Soon
                        </Button>
                      ) : (
                        <button
                          className={styles.removeBtn}
                          style={{ color: "#2979FF" }}
                          onClick={() => handleSelect(item, list.name)}
                        >
                          <img
                            src={Add}
                            height={15}
                            width={15}
                            style={{ marginRight: "5px" }}
                            alt="+"
                          />
                          Add
                        </button>
                      )}
                    </div>
                  );
                })}
              </Panel>
            ))}
          </Collapse>
        </div>
      ) : current === 2 ? (
        <div style={{ marginTop: "2rem" }}>
          <div className={styles.step2Box}>
            {addItem?.map((item, i) => {
              return (
                <div
                  key={i}
                  className={
                    !drawingData.hasOwnProperty(item._id)
                      ? styles.itemBox2
                      : styles.itemBox
                  }
                >
                  <div
                    style={{ display: "flex", alignItems: "center" }}
                    className={styles.fontSizeChange}
                  >
                    {item.name}{" "}
                    {drawingData.hasOwnProperty(item._id) && (
                      <img
                        src={checkWhite}
                        height={15}
                        width={15}
                        style={{ marginLeft: "5px" }}
                        alt="x"
                      />
                    )}
                  </div>
                  {!drawingData.hasOwnProperty(item._id) ? (
                    <button
                      className={styles.markBondary}
                      onClick={() => handleOpen(item._id)}
                    >
                      <img
                        src={pen}
                        height={15}
                        width={15}
                        style={{ marginRight: "5px" }}
                        alt="x"
                      />
                      Mark Crossing
                      <img
                        src={polygon}
                        height={15}
                        width={15}
                        style={{ marginLeft: "5px" }}
                        alt="x"
                      />
                    </button>
                  ) : (
                    <button
                      className={styles.removeBtn}
                      style={{ color: "#2979FF", marginLeft: "5px" }}
                      onClick={() => handleOpen(item._id)}
                    >
                      Edit
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div style={{ marginTop: "2rem" }}>
          <div
            className={styles.flexDiv}
            style={{
              borderBottomRightRadius: 0,
              borderBottomLeftRadius: 0,
            }}
          >
            <span>Video</span>
          </div>
          <div
            className={styles.flexDiv}
            style={{
              marginTop: "1.5px",
              paddingBlock: "20px",
              borderTopRightRadius: 0,
              borderTopLeftRadius: 0,
            }}
          >
            <div>
              Length: <span>{videoDetails?.videoDuration}</span>
            </div>
            <div>
              Size: <span>{videoDetails?.videoSize}</span>
            </div>
            <div>
              Source: <span>Device</span>
            </div>
          </div>
          <div
            className={styles.flexDiv}
            style={{
              marginTop: "8px",
              paddingBlock: "20px",
              borderBottomRightRadius: 0,
              borderBottomLeftRadius: 0,
            }}
          >
            <span>Use Cases</span>
          </div>
          <div
            className={styles.flexDiv}
            style={{
              marginTop: "1.5px",
              paddingBlock: "20px",
              borderTopRightRadius: 0,
              borderTopLeftRadius: 0,
            }}
          >
            <div>
              {addItem.map((item, i) => (
                <div style={{ fontWeight: 600 }} key={i}>
                  {item.name}
                </div>
              ))}
            </div>
            <div>
              {addItem.map((item, i) => {
                return drawingData[item._id]?.lines?.length ||
                  drawingData[item._id]?.polygons?.length ? (
                  <div key={i}>
                    Boundary Marked
                    <img
                      src={check}
                      height={15}
                      width={15}
                      style={{ marginLeft: "5px" }}
                      alt="+"
                    />
                  </div>
                ) : (
                  <div key={i}>Boundary Mark Pending</div>
                );
              })}
            </div>
            <div style={{ paddingRight: "5px" }}>
              {addItem.map((item, i) => (
                <div
                  key={i}
                  style={{
                    fontWeight: 500,
                    color: "#2979FF",
                    cursor: "pointer",
                  }}
                  onClick={() => handleOpen(item._id)}
                >
                  Review
                </div>
              ))}
            </div>
          </div>
          {/* <div
            className={styles.flexDiv}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderBottomRightRadius: 0,
              borderBottomLeftRadius: 0,
              marginTop: "0.5rem",
            }}
          >
            <span>Price</span>
            <span>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "green",
                }}
              >
                Available Credit - <MdOutlineCurrencyRupee />{" "}
                {creditScore?.credit_score -
                  addItem.reduce(
                    (a, b) =>
                      a +
                      b.price * convertToMinutes(videoDetails?.videoDuration),
                    0
                  )}
                  null
              </div>
            </span>
          </div> */}
          <div
            className={styles.flexDiv}
            style={{
              marginTop: "1.5px",
              paddingBlock: "20px",
              borderTopRightRadius: 0,
              borderTopLeftRadius: 0,
            }}
          >
            <div>
              {addItem.map((item, i) => (
                <div style={{ fontWeight: 600 }} key={i}>
                  {item.name}
                </div>
              ))}
            </div>
            <div>
              {addItem.map((item, i) => {
                return (
                  <div key={i}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <MdOutlineCurrencyRupee /> {item.price} *{" "}
                      {convertToMinutes(videoDetails?.videoDuration)}
                    </div>
                  </div>
                );
              })}

              <div>
                <hr
                  style={{
                    padding: 0,
                    margin: 0,
                    borderTop: "3px solid",
                    backgroundColor: "#000",
                  }}
                />{" "}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <MdOutlineCurrencyRupee />
                  {addItem.reduce(
                    (a, b) =>
                      a +
                      b.price * convertToMinutes(videoDetails?.videoDuration),
                    0
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.flexDiv} style={{ marginTop: "1rem" }}>
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  paddingBottom: "5px",
                }}
              >
                <img
                  src={lightbulb}
                  height={15}
                  width={15}
                  style={{ marginRight: "5px" }}
                  alt="+"
                />
                <span>
                  After submission you will be redirected to{" "}
                  <b style={{ fontWeight: "500" }}>Report.</b>
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src={lightbulb}
                  height={15}
                  width={15}
                  style={{ marginRight: "5px" }}
                  alt="+"
                />
                <span>
                  Report can also be seen anytime in{" "}
                  <b style={{ fontWeight: "600" }}>Video</b> and{" "}
                  <b style={{ fontWeight: "600" }}>Report</b> section.
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      <div
        style={{
          marginTop: 30,
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        {current > 0 && (
          <Button
            size="large"
            style={{
              margin: "0 8px",
            }}
            disabled={selectedPipeline?._id ? true : false}
            onClick={() => prev()}
          >
            Previous
          </Button>
        )}
        {current < steps.length - 1 && (
          <Button
            type="primary"
            size="large"
            disabled={isDisableBtn(current)}
            onClick={() => {
              current === 0 ? uploadVideo() : next();
            }}
            className={styles.nextBtn}
          >
            Next
          </Button>
        )}
        {current === steps.length - 1 && (
          <Button
            type="primary"
            size="large"
            disabled={isDisableBtn(current) || doneBtnClick}
            onClick={createMedia}
          >
            Done
          </Button>
        )}
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <span
            style={{
              position: "absolute",
              top: 0,
              right: "5px",
              cursor: "pointer",
            }}
            onClick={handleClose}
          >
            <img
              src={X}
              height={20}
              width={20}
              style={{ marginRight: "5px" }}
              alt="x"
            />
          </span>

          <ImageAnnotate
            imgUrl={url}
            handleSubmit={handleSubmitAnnotate}
            drawingData={selectedAlert ? drawingData[selectedAlert] : null}
            showTab={
              addItem.length
                ? addItem?.filter((item) => item._id === selectedAlert)[0]
                    ?.marking
                : []
            }
            setToDivid={setToDivid}
            isRuleChange={addItem?.some(
              (item) => item?._id === "65ae0bf6b52522368a248f01"
            )}
            selectedAlert={selectedAlert}
            roiName={roiName}
            setRoiName={setRoiName}
            lcName={lcName}
            setLcName={setLcName}
            camId={deviceList.filter((item) => item.value === rtspUrl)[0]?.id}
          />
        </Box>
      </Modal>
    </>
  );
};
export default Step2;
